import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const VideoAiTab = ({ tabValue, handleChangeTab, makingVideo }) => {
  return (
    <Box sx={{ width: "300px" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Tab label="1:1" disabled={makingVideo} {...a11yProps(0)} />
          <Tab
            // disable the tab
            disabled={makingVideo}
            label="16:9"
            {...a11yProps(1)}
          />
          <Tab disabled={makingVideo} label="9:16" {...a11yProps(2)} />
        </Tabs>
      </Box>
    </Box>
  );
};

export default VideoAiTab;
